module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pa-3 full-width"
  }, [_c('div', {
    staticClass: "chart-heading mb-2 ml-1"
  }, [_vm._v("Submissions")]), _vm._v(" "), _c('div', {
    staticClass: "elevation-1 white pa-3 mb-4 rounded"
  }, [_vm._v("\n\n        This month " + _vm._s(_vm.formatMillions(_vm.amountSubmittedThis)) + "\n        "), _c('v-progress-linear', {
    staticClass: "mb-4",
    attrs: {
      "height": "8",
      "rounded": "",
      "value": _vm.amountSubmittedThis / _vm.targetSubmissions * 100
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "light-text"
  }, [_vm._v("Target " + _vm._s(_vm.targetSubmissionsMillions) + " with " + _vm._s(_vm.daysThisMonth - _vm.dayOfMonth) + " days remaining")]), _vm._v(" "), _c('v-progress-linear', {
    staticClass: "mb-4",
    attrs: {
      "color": "grey",
      "height": "8",
      "rounded": "",
      "value": _vm.dayOfMonth / _vm.daysThisMonth * 100
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "elevation-1 white pa-3 mb-4 rounded "
  }, [_vm._v("\n        Last month " + _vm._s(_vm.formatMillions(_vm.amountSubmittedLast)) + "\n        "), _c('v-progress-linear', {
    attrs: {
      "height": "8",
      "color": "purple",
      "rounded": "",
      "value": _vm.amountSubmittedLast / _vm.targetSubmissions * 100
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "chart-heading mb-2 ml-1"
  }, [_vm._v("Settlements")]), _vm._v(" "), _c('div', {
    staticClass: "elevation-1 white pa-3 mb-4 rounded"
  }, [_vm._v("\n        This month " + _vm._s(_vm.formatMillions(_vm.amountSettledThis)) + "\n        "), _c('v-progress-linear', {
    staticClass: "mb-4",
    attrs: {
      "height": "8",
      "rounded": "",
      "value": _vm.amountSettledThis / _vm.targetSubmissions * 100
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "light-text"
  }, [_vm._v("Target " + _vm._s(_vm.targetSettlementsMillions) + " with " + _vm._s(_vm.daysThisMonth - _vm.dayOfMonth) + " days remaining")]), _vm._v(" "), _c('v-progress-linear', {
    staticClass: "mb-4",
    attrs: {
      "color": "grey",
      "height": "8",
      "rounded": "",
      "value": _vm.dayOfMonth / _vm.daysThisMonth * 100
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "elevation-1 white pa-3 rounded mb-10"
  }, [_vm._v("\n        Last month " + _vm._s(_vm.formatMillions(_vm.amountSettledLast)) + "\n        "), _c('v-progress-linear', {
    attrs: {
      "height": "8",
      "color": "purple",
      "rounded": "",
      "value": _vm.amountSettledLast / _vm.targetSubmissions * 100
    }
  })], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "depressed": "",
      "rounded": ""
    },
    on: {
      "click": function($event) {
        _vm.dialog.settings.visible = true
      }
    }
  }, [_vm._v("Set Targets")]), _vm._v(" "), (false) ? _c('NoRecordsPlaceholder', [_vm._v("\n        Nothing tomorrow!\n    ")]) : _vm._e(), _vm._v(" "), _c('DialogBox', {
    attrs: {
      "title": "Settings",
      "settings": _vm.dialog.settings
    },
    on: {
      "close": function($event) {
        return _vm.saveSettings()
      }
    }
  }, [_c('div', {
    staticClass: "pa-3"
  }, [_c('div', [_vm._v("Target Submissions " + _vm._s(_vm.targetSubmissionsMillions))]), _vm._v(" "), _c('v-slider', {
    attrs: {
      "min": "0",
      "max": "30000000",
      "step": "100000"
    },
    model: {
      value: (_vm.targetSubmissions),
      callback: function($$v) {
        _vm.targetSubmissions = $$v
      },
      expression: "targetSubmissions"
    }
  }), _vm._v(" "), _c('div', [_vm._v("Target Settlements " + _vm._s(_vm.targetSettlementsMillions))]), _vm._v(" "), _c('v-slider', {
    attrs: {
      "min": "0",
      "max": "30000000",
      "step": "100000"
    },
    model: {
      value: (_vm.targetSettlements),
      callback: function($$v) {
        _vm.targetSettlements = $$v
      },
      expression: "targetSettlements"
    }
  })], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-58744f96"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Charts/VolumeChart.vue
// module id = 2559
// module chunks = 1